module.exports = __webpack_public_path__ + "img/project-details-1.bddd0eb1.jpg";